import toast from 'react-hot-toast';
import useApi from '../useApi';

interface UpdateTimeSpentProps {
  patientId: string;
  clinicId: string;
}

interface UpdateTimeSpentRequest {
  timeInSeconds: number;
}

interface UpdateTimeSpentResponse {
  status: string;
  message?: string;
}

const useUpdateTimeSpent = ({ patientId, clinicId }: UpdateTimeSpentProps) => {
  const url = `/rtm/timer/update-time-spent?associatedClinicianId=${clinicId}&patientId=${patientId}`;
  const method = 'POST';
  const { loading: isLoading, makeApiCall } = useApi({ url, method });

  const updateTimeSpent = async (formData: UpdateTimeSpentRequest) => {
    const { response, error } = await makeApiCall<UpdateTimeSpentRequest, UpdateTimeSpentResponse>(formData);

    if (response?.status === 'success') {
      toast.success('Time spent updated successfully');
      return response;
    }

    if (error || !response?.status) {
      toast.error('Failed to update time spent');
      return { status: 'fail' };
    }
  };

  return {
    updateTimeSpent,
    isLoading,
  };
};

export default useUpdateTimeSpent; 